import icon from "@material-ui/icons/LocalShipping";

export const InvoiceIcon = icon;

export default {
  icon
};
